import clsx from 'clsx';
import React from 'react';

const TaggedItem = (props) => {
  const { filename, newValue, oldValue, title, useTitle } = props;
  // const isUpdate = oldValue && !newValue;
  // const isDelete = !oldValue && !newValue;
  const isUpdate = oldValue !== null && oldValue !== newValue && newValue !== null;
  const isDelete = oldValue && newValue === null;
  let oldValueLabel = <span></span>;
  let newValueLabel = <span></span>;
  let actionTypeLabel = '';

  if (isUpdate) {
    actionTypeLabel = ' update tag ';
  } else if (isDelete) {
    actionTypeLabel = ' delete tag ';
  } else {
    actionTypeLabel = ' create tag ';
  }

  actionTypeLabel += ' of ';

  if (oldValue) {
    oldValueLabel = (
      <span>
        <span className={clsx('tw-text-cfo-black')}> from </span>
        <strong className={clsx('tw-text-cfo-black tw-font-brandonTextBold')}>
          {`${oldValue}`}
        </strong>
      </span>
    );
  }

  if (newValue) {
    newValueLabel = (
      <span>
        <span className={clsx('tw-text-cfo-black')}> to </span>
        <strong className={clsx('tw-text-cfo-black tw-font-brandonTextBold')}>
          {`${newValue}`}
        </strong>
      </span>
    );
  }

  if (useTitle) {
    return (
      <React.Fragment>
        <span className={clsx('tw-text-cfo-black')}> {title} </span>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <span className={clsx('tw-text-cfo-black')}> {actionTypeLabel} </span>
      <span className={clsx('tw-text-cfo-blue-600 tw-font-brandonTextBold tw-underline')}>
        {filename}
      </span>
      {oldValueLabel}
      {newValueLabel}
    </React.Fragment>
  );
};

export default TaggedItem;
